import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import * as search from '@webapp/sdk/search';
import { Actions } from '../../actions';
import {
  SearchCategories,
  SearchCategoriesSuccess,
  SearchCategoriesError,
} from '../action-creators';
import { SEARCH_CATEGORIES } from '../actions';
import { Category } from '@common/types/categories/category';

export const searchCategoriesEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, SearchCategories>(SEARCH_CATEGORIES),
    mergeMap(async (action) => {
      try {
        const results = await (search as any)[action.contentType](action.query);
        const categoryList: Category[] = results.hits.hits.map(
          (r: any) => r._source
        );

        return new SearchCategoriesSuccess(action.contentType, categoryList);
      } catch (err) {
        return new SearchCategoriesError((err as Error).message);
      }
    })
  );
